import React from 'react';

import Row from './row';

const List = ({ columns, userEntries, questions }) => {
  return userEntries && userEntries.length > 0
    ? userEntries.map((userEntry, i) => (
        <Row
          position={i + 1}
          columns={columns}
          key={`entry-${userEntry.user.id}`}
          userEntry={userEntry}
          questions={questions}
        />
      ))
    : null;
};

export default List;
